export var DEFAULT_SELECTED_TYPES = ['DataCard'];
var OfferUsableOption = /*@__PURE__*/ (function () {
    function OfferUsableOption(data) {
        if (data) {
            if (data.id) {
                this.id = data.id;
            }
            if (data.price) {
                this.price = data.price;
            }
            if (data.prices) {
                this.prices = data.prices;
            }
            if (data.description) {
                this.description = data.description;
            }
        }
    }
    return OfferUsableOption;
}());
export { OfferUsableOption };
export function OptionDefaultIncluded(option) {
    if (option.description) {
        if (option.description.label) {
            return DEFAULT_SELECTED_TYPES.indexOf(option.description.label) > -1;
        }
    }
    return false;
}



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.usable-option.ts
// module id = w0hO
// module chunks = 0 2